
import { LogoUploader } from "@/components/ui/logo-uploader/LogoUploader";

interface CompanyLogoUploaderProps {
  logoUrl: string;
  companyInitials: string;
  handleLogoChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isLoading: boolean;
}

export function CompanyLogoUploader({
  logoUrl,
  companyInitials,
  handleLogoChange,
  isLoading
}: CompanyLogoUploaderProps) {
  return (
    <LogoUploader 
      logoUrl={logoUrl}
      fallback={companyInitials}
      handleLogoChange={handleLogoChange}
      isLoading={isLoading}
      variant="avatar"
      size="md"
      maxSizeInMB={1}
    />
  );
}
